const MainSettings = require('./../../main.config.js')
const { projectapi } = require('../projects/' + MainSettings.activeProject + '/config/api.js')

export const api = {
    url: projectapi.url,
    path: projectapi.path,
    storage: projectapi.storage
}
